export const WC_PROJECT_ID = 'e24844c5deb5193c1c14840a7af6a40b';
